import { Link } from "react-router-dom";

export default function AboutTMS() {
  const ResetLocation = () => window.scrollTo(0, 0);
  return (
    <article className="py-5  bg-primary text-white overflow-hidden">
      <section className="container mx-auto">
        <section className="text-center mb-4">
          <h2 className="text-uppercase fw-semibold">
            CRM & Ticket Management System
          </h2>
          <p className="h2 fw-bold">
            Streamlining Customer Service & Field Operations
          </p>
        </section>
        <section className="bg-primary p-4 rounded shadow-lg">
          <div className="row g-4">
            <div className="col-md-6">
              <h3 className="h4 fw-bold">Project Overview</h3>
              <p>
                Fieldsathi is a comprehensive CRM and Ticket Management System
                designed to efficiently handle leads, customer service, repairs,
                installations and other field related activities.It enables
                seamless assignment, tracking, and resolution of customer
                requests, ensuring high productivity and customer satisfaction.
              </p>
              <h3 className="h4 fw-bold mt-3">Key Benefits</h3>
              <ul className="list-group list-group-flush">
                <li className="list-group-item bg-primary text-white">
                  Streamline field operations
                </li>
                <li className="list-group-item bg-primary text-white">
                  Improve agent productivity
                </li>
                <li className="list-group-item bg-primary text-white">
                  Efficient team management
                </li>
                <li className="list-group-item bg-primary text-white">
                  Enhance customer satisfaction
                </li>
              </ul>
            </div>
            <div className="col-md-6">
              <h3 className="h4 fw-bold">Process Flow</h3>
              <ol className="list-group list-group-numbered">
                <li className="list-group-item bg-primary text-white">
                  <strong>Create Request:</strong> Calls, Emails, Manual Entry
                </li>
                <li className="list-group-item bg-primary text-white">
                  <strong>Create Tickets:</strong> Service, Repair, Inspection,
                  Installation & others
                </li>
                <li className="list-group-item bg-primary text-white">
                  <strong>Scheduling:</strong> Assign a Field team
                </li>
                <li className="list-group-item bg-primary text-white">
                  <strong>Push Notifications:</strong> Mobile & Email alerts
                </li>
                <li className="list-group-item bg-primary text-white">
                  <strong>Start Work:</strong> Field team arrives and updates
                  status
                </li>
                <li className="list-group-item bg-primary text-white">
                  <strong>Complete Work:</strong> Task marked as completed
                </li>
                <li className="list-group-item bg-primary text-white">
                  <strong>Close Request:</strong> Service request closed upon
                  payment
                </li>
              </ol>
            </div>
          </div>
          <div className="mt-4 text-center">
            <Link
              onClick={ResetLocation}
              to="/contact"
              className="btn btn-light text-primary fw-bold px-4 py-2"
            >
              Contact us
            </Link>
          </div>
        </section>
      </section>
    </article>
  );
}
